import PropTypes from 'prop-types';
import React__default, { useRef } from 'react';
import { useTheme } from 'styled-components';
import { WithDarkTheme } from '@statsbomb/kitbag-themes';
import { Aside, Nav } from './SideNavigation.styles.js';
import { SideNavigationThemeProvider } from '../SideNavigationContexts/SideNavigationThemeContext.js';
import { SideNavigationKeyboardProvider } from '../SideNavigationContexts/SideNavigationKeyboardContext.js';

var SideNavigation = function SideNavigation(_ref) {
  var _useTheme;
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$isTouch = _ref.isTouch,
    isTouch = _ref$isTouch === void 0 ? false : _ref$isTouch,
    children = _ref.children,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var sideNavigationRef = useRef();
  var renderOriginalTheme = isTouch && !isOpen;
  var Component = !renderOriginalTheme ? WithDarkTheme : React__default.Fragment;
  var isDarkMode = (_useTheme = useTheme()) === null || _useTheme === void 0 ? void 0 : _useTheme.isDark;
  return React__default.createElement(SideNavigationThemeProvider, {
    value: {
      isDarkMode: isDarkMode,
      isOpen: isOpen,
      isTouch: isTouch
    }
  }, React__default.createElement(SideNavigationKeyboardProvider, {
    sideNavigationRef: sideNavigationRef
  }, React__default.createElement(Component, null, React__default.createElement(Aside, {
    ref: sideNavigationRef,
    $isOpen: isOpen,
    $isTouch: isTouch,
    "data-testid": testId
  }, React__default.createElement(Nav, {
    $isOpen: isOpen,
    $isTouch: isTouch,
    $isDarkMode: renderOriginalTheme
  }, children)))));
};
SideNavigation.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  isTouch: PropTypes.bool,
  testId: PropTypes.string
};

export { SideNavigation, SideNavigation as default };
//# sourceMappingURL=SideNavigation.js.map
